const SHARES = [
  { pct: "50%", caption: "with one other family" },
  { pct: "33%", caption: "with two other families" },
  { pct: "25%", caption: "with three other families" },
];

export default function Solution() {
  return (
    <section
      data-testid="solution-section"
      className="relative bg-[var(--ink)] text-[var(--bone)] overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-44 relative">
        <div className="max-w-3xl reveal">
          <div className="text-overline text-[var(--gold)] mb-6">The Solution</div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.8rem] leading-[1.05] tracking-tight">
            Own a piece of Israel.
            <br />
            <span className="italic text-[var(--bone)]/85">
              Not a week — but six months, three months,
            </span>
            <br />
            <span className="italic text-[var(--bone)]/85">
              and rent it out when you’re not living in it.
            </span>
          </h2>
          <p className="mt-7 md:mt-9 text-[var(--bone)]/75 text-base md:text-lg leading-relaxed font-light max-w-2xl">
            Premium apartments. Real, registered ownership. A small, hand‑matched group of
            families who share your values, your rhythm and your standard of care.
          </p>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--bone)]/10 border border-[var(--bone)]/15">
          {SHARES.map((s, i) => (
            <div
              key={s.pct}
              data-testid={`solution-share-${i}`}
              className="bg-[var(--ink)] p-10 md:p-14 reveal"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className="font-serif-display text-7xl md:text-8xl lg:text-[8.5rem] leading-none tracking-tighter text-[var(--bone)]">
                {s.pct}
              </div>
              <div className="mt-4 text-overline text-[var(--gold)]">Co‑ownership</div>
              <div className="mt-3 text-[var(--bone)]/70 text-base font-light">{s.caption}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          <div className="reveal">
            <div className="text-overline text-[var(--gold)] mb-3">Legal Constitution</div>
            <p className="text-[var(--bone)]/75 font-light leading-relaxed">
              A clear, signed framework governing usage, costs, rentals, exit rights,
              succession and dispute resolution — drafted by reputable Israeli counsel.
            </p>
          </div>
          <div className="reveal" style={{ transitionDelay: "0.08s" }}>
            <div className="text-overline text-[var(--gold)] mb-3">Full‑Service Management</div>
            <p className="text-[var(--bone)]/75 font-light leading-relaxed">
              From the moment the keys are handed over — maintenance, cleaning, bills,
              taxes, rentals and changeovers. You travel. We handle Israel.
            </p>
          </div>
          <div className="reveal" style={{ transitionDelay: "0.16s" }}>
            <div className="text-overline text-[var(--gold)] mb-3">Curated Co‑Owners</div>
            <p className="text-[var(--bone)]/75 font-light leading-relaxed">
              Matched on values, budget, usage and lifestyle. No timeshare draws,
              no surprises — just families who share what you share.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
